import BaseLayout from '../layout/BaseLayout';
import ChargerManagement from '../components/ChargerManagement/ChargerManagement';

export default function ChargerManagementPage() {
  return <BaseLayout child={<ChargerManagement />} />;
}
